import { useSelector } from 'react-redux';

import { selectPurchaseRetentionOffers } from '@app/redux/disconnect';

import ErrorModal from './ErrorModal';
import LoadingModal from './LoadingModal';
import SuccessModal from './SuccessModal';
import { ModalProps } from '../../types';

interface PurchaseModalProps extends ModalProps {
  retentionOfferName: string;
}

const PurchaseModal = ({ isOpen, handleCancel, retentionOfferName, handleContinue }: PurchaseModalProps) => {
  const { error, loading, success } = useSelector(selectPurchaseRetentionOffers);
  if (loading) {
    return <LoadingModal isOpen={isOpen} />;
  }
  if (error) {
    return <ErrorModal isOpen={isOpen} handleCancel={handleCancel} />;
  }
  if (success) {
    return (
      <SuccessModal
        isOpen={isOpen}
        handleCancel={handleCancel}
        retentionOfferName={retentionOfferName}
        handleContinue={handleContinue}
      />
    );
  }

  return null;
};

export default PurchaseModal;
